import { ArrowLeft, Compass } from "lucide-react";
import { Link } from "react-router-dom";

import { HeaderText } from "@src/shared/components/general/HeaderText";
import { Text } from "@src/shared/components/general/Text";
import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";
import { navigationV2 } from "@src/shared/navigation/v2";

/**
 * 404 surface for the v2 route tree, rendered both by the `/not-found` route and
 * by `ErrorBoundaryV2` when React Router throws its no-match 404 response. The
 * recovery link resolves through `navigationV2` so it always points at a route
 * the v2 tree actually mounts.
 */
export function NotFoundPageV2() {
  return (
    <VerticalFlexbox
      alignItems="center"
      justifyContent="center"
      gap="md"
      className="min-h-[60vh] w-full px-6 py-12 text-center"
    >
      <VerticalFlexbox
        alignItems="center"
        justifyContent="center"
        className="size-[46px] rounded-[13px] bg-accent text-primary"
      >
        <Compass className="size-[22px]" aria-hidden="true" />
      </VerticalFlexbox>
      <HeaderText
        tag="h1"
        className="text-[42px] leading-none tracking-[-1.2px]"
      >
        404
      </HeaderText>
      <Text
        as="p"
        appearance="subdued"
        sizing="sm"
        className="max-w-[350px] text-balance leading-[1.55]"
      >
        The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
      </Text>
      <Button
        asChild
        className="mt-2 h-[42px] rounded-[9px] text-[13.5px] font-semibold"
      >
        <Link to={navigationV2.home()}>
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back to Home
        </Link>
      </Button>
    </VerticalFlexbox>
  );
}
